import { connect }                    from 'react-redux';
import * as PropTypes                 from 'prop-types';
import {
    compose,
    branch,
    lifecycle,
    renderComponent,
    getContext,
    withState,
    withProps,
    withContext,
}                                     from 'recompose';
import { loadRecipient }              from '../Recipient/RecipientActions';
import { withRouter }                 from 'react-router';
import { ConversationContainerProps } from './ConversationTypes';
import TranslationsContainer          from '../Translations';

// presentation components
import ConversationLoader             from './ConversationLoader';
import ErrorMessage                   from '../../components/ErrorMessage';
import Conversation                   from './ConversationComponent';
import getQueryStringKey              from '../../helpers/getQueryStringKey';

const mapStateToProps = ({ recipientsStore }, { match: { params: { conversationId }}}: ConversationContainerProps) => {
    return {
        conversationId: parseInt(conversationId, 10), // actions expect a number
        error: recipientsStore.error,
        loading: recipientsStore.loading,
        recipient: recipientsStore.recipients[`recipient_${conversationId}`]
    };
};

const getCallListStatus = (): boolean => getQueryStringKey('list') === 'call' || Boolean(getQueryStringKey('calllist_id'));

const isLoading = ({ loading }) => loading;
const hasError  = ({ error }) => error;

const mapDispatchers = (dispatch) => ({
    loadRecipient(conversationId, shouldShowLoading: boolean = true) {
        dispatch(loadRecipient(conversationId, shouldShowLoading));
    }
});

const LoadingRender = renderComponent(ConversationLoader);
const ErrorRender   = renderComponent(ErrorMessage);

const ConversationContainer = compose(
    withRouter,
    TranslationsContainer,
    connect(mapStateToProps, mapDispatchers),
    withContext({
        isOnCallList: PropTypes.bool.isRequired
    }, () => ({
        isOnCallList: getCallListStatus()
    })),
    getContext({
        onDesktop: PropTypes.bool,
        session: PropTypes.any.isRequired
    }),
    withState('contactPanelVisible', 'updatePanel', false),
    withProps(({ contactPanelVisible, updatePanel, onDesktop }) => ({
        toggleContactPanel: () => onDesktop ? null : updatePanel(!contactPanelVisible),
    })),
    lifecycle<ConversationContainerProps, {}>({
        componentWillMount() {
            this.props.loadRecipient(this.props.conversationId);
        },
        componentWillUpdate(nextProps) {
            const { match: { params: { conversationId }}} = nextProps;

            if (this.props.match.params.conversationId !== conversationId) {
                const shouldShowLoading = !Boolean(nextProps.recipient);

                return nextProps.loadRecipient((conversationId as any), shouldShowLoading);
            }
        },
    }),
    branch(isLoading, LoadingRender),
    branch(hasError, ErrorRender),
);

export default ConversationContainer(Conversation) as React.ComponentClass<ConversationContainerProps>;



// WEBPACK FOOTER //
// ./src/sections/Conversation/index.ts